import Team1 from '../assets/images/team1.png';
import Team3 from '../assets/images/team3.png';
import Team4 from '../assets/images/team4.png';
import Team5 from '../assets/images/team5.png';
import Team7 from '../assets/images/team7.png';
import Team8 from '../assets/images/team8.png';
import Team9 from '../assets/images/team9.png';

export default [
  {
    img: Team1,
    name: 'Oluwaferanmi Owolabi',
    role: 'Vice Chancellor, Purple Academy'
  },
  {
    img: Team4,
    name: 'Rilwan Abdul',
    role: 'Dean, Banking School'
  },
  {
    img: Team3,
    name: 'Temiloluwa Sulaiman',
    role: 'Dean, Culture & Leadership School'
  },
  {
    img: Team5,
    name: 'Temitope Alonge',
    role: 'Dean, Business & SME Business School'
  },
  {
    img: Team9,
    name: 'Fhard Saba',
    role: 'Programme Manager, Foundation School'
  },
  {
    img: Team8,
    name: 'Atinuke Onifade',
    role: 'Career Management & Planning Officer'
  },
  {
    img: Team7,
    name: 'Mojeed Yusuf',
    role: 'Digital Learning & Innovation Officer',
    objectPosition: 'center center'
  }
];
